import { handleActions } from "redux-actions";
import types from "../types/user";

const INITIAL_STATE = {
  id: null,
  name: null,
  loggedIn: false,
};

const handleLoginChange = payload => state => ({ ...state, loggedIn: payload });

export const user = handleActions({
  [types.LOGIN_SUCCESS]: handleLoginChange(true),
  [types.LOGIN_LOGOUT]: handleLoginChange(false)
}, INITIAL_STATE);

export default user;



// WEBPACK FOOTER //
// ./src/redux/reducers/user.js